import React, { useState, useEffect } from "react";

const CountryCode = ({
  countryCode,
  setCountryCode,
  allCountryCode,
  setAllCountryCode,
  style,
  register,
  setCountryCodeLength,
  countryCodeLength,
  errors,
}) => {
  const [triggerCode, setTriggerCode] = useState(false);

  useEffect(() => {
    if (countryCode) {
      const matchingCountries = allCountryCode.filter(
        (country) =>
          country.dial_code
            .toLowerCase()
            .startsWith(countryCode.toLowerCase()) ||
          country.name.toLowerCase().startsWith(countryCode.toLowerCase()) ||
          country.code.toLowerCase().startsWith(countryCode.toLowerCase())
      );

      const nonMatchingCountries = allCountryCode.filter(
        (country) =>
          !(
            country.dial_code
              .toLowerCase()
              .startsWith(countryCode.toLowerCase()) ||
            country.name.toLowerCase().startsWith(countryCode.toLowerCase()) ||
            country.code.toLowerCase().startsWith(countryCode.toLowerCase())
          )
      );

      setAllCountryCode([...matchingCountries, ...nonMatchingCountries]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [countryCode]);

  useEffect(() => {
    if (countryCode) {
      let matchedCountryCode = allCountryCode?.find(
        (country) => country.dial_code === countryCode
      );
      if (
        matchedCountryCode &&
        Array.isArray(matchedCountryCode?.phoneLength)
      ) {
        setCountryCodeLength({
          min: matchedCountryCode.phoneLength[0],
          max: matchedCountryCode.phoneLength[
            matchedCountryCode.phoneLength?.length - 1
          ],
        });
      } else if (matchedCountryCode) {
        setCountryCodeLength({
          min: matchedCountryCode.phoneLength,
          max: matchedCountryCode.phoneLength,
        });
      }
    }
  }, [allCountryCode, countryCode, setCountryCodeLength]);

  return (
    <>
      <label htmlFor="mobile" className="text-[14px] font-[500] pl-1">
        <>
          Phone Number&nbsp;<span className="text-red-500">*</span>
        </>
      </label>
      <div className="mymd:w-full flex w-[100%] justify-between relative gap-2 mt-1">
        <div
          className="relative pr-2.5
             peer bg-[#F4F6F9] border-[1px] border-[#C5C5C7] text-gray-900 text-[13px] rounded-lg h-[40px] placeholder-transparent focus:ring-transparent focus:border-primary focus:border-[2px] dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white font-medium dark:focus:ring-blue-500 dark:focus:border-blue-500 flex py-0 items-center"
        >
          <div className="flex items-center relative">
            <label htmlFor="code" className="hidden">
              Code
            </label>
            <input
              type="text"
              id="code"
              required
              value={countryCode}
              onFocus={() => setTriggerCode(true)}
              onBlur={() => setTriggerCode(false)}
              onChange={(event) => {
                const { value } = event.target;
                const hasPlus = value?.includes("+");
                const isNumber = /^\d+$/.test(value);
                setCountryCode(event.target.value);
                if (isNumber && hasPlus) {
                  setCountryCode(event.target.value);
                } else if (isNumber && !hasPlus) {
                  setCountryCode("+" + event.target.value);
                } else if (!isNumber) {
                  setCountryCode(event.target.value);
                }
              }}
              // {...register("code")}
              className={`w-[55px]
                    peer bg-[#F4F6F9] border-0 border-gray-300 text-gray-900 text-[13px] rounded-lg h-[30px] placeholder-transparent focus:ring-transparent block pl-1.5 focus:border-primary focus:border-0 font-medium`}
              autoComplete="off"
            />
            <img
              src="/svgs/arrow.svg"
              alt=""
              onClick={() => setTriggerCode(!triggerCode)}
              className="transform rotate-180 h-[16px] cursor-pointer ml-2 mr-3"
            />
          </div>

          {triggerCode && (
            <div className="border max-h-[130px] absolute w-[83px] z-20 bg-white overflow-y-scroll rounded-lg border-primary top-[40px]">
              {allCountryCode?.map((codes) => (
                <span
                  className="w-[100%] flex h-[40px] items-center pl-2 text-[12px] font-[500] cursor-pointer hover:bg-gray-200 "
                  onMouseDown={(event) => {
                    setCountryCode(codes.dial_code);

                    setTriggerCode(false);
                    if (Array.isArray(codes.phoneLength)) {
                      setCountryCodeLength({
                        min: codes.phoneLength[0],
                        max: codes.phoneLength[codes.phoneLength.length - 1],
                      });
                    } else {
                      setCountryCodeLength({
                        min: codes.phoneLength,
                        max: codes.phoneLength,
                      });
                    }
                    event.stopPropagation();
                  }}
                >
                  {codes.code} {codes.dial_code}
                </span>
              ))}
            </div>
          )}
        </div>

        <div
          className="w-[100%] bg-[#F4F6F9] rounded-lg"
          onClick={() => setTriggerCode(false)}
        >
          <input
            type="tel"
            id="mobile"
            minLength={countryCodeLength?.min}
            maxLength={countryCodeLength?.max}
            required
            className={`w-[100%]
                bg-[#F4F6F9] border-[1px] border-[#C5C5C7] text-gray-900 text-[13px] h-[40px] placeholder-transparent p-0 appearance-none bg-transparent focus:outline-none pl-2 focus:border-primary focus:border-[1px] block font-medium rounded-lg focus:ring-1 focus:ring-primary
                 `}
            // {...register("mobile")}
            {...register("mobile", {
              required: "Field cannot be empty",
              validate: (value) => {
                const trimmedValue = value?.toString()?.trim();
                const regex = new RegExp(
                  `^[\\d]{${countryCodeLength?.min},${countryCodeLength?.max}}$`
                );

                if (trimmedValue && !regex.test(trimmedValue)) {
                  return `Invalid number (Min: ${countryCodeLength?.min}, Max: ${countryCodeLength?.max})`;
                }
                return true;
              },
            })}
            style={{ backgroundColor: "transparent" }}
          />
          {errors?.mobile && (
            <p className="absolute text-red-500 text-[11px] font-[500] mt-[2px]">
              {errors?.mobile && <p>{errors?.mobile?.message}</p>}
            </p>
          )}
        </div>
      </div>
    </>
  );
};

export default CountryCode;
